import React, { useEffect, useRef, useState } from 'react';
import debounce from 'lodash.debounce';

import { ClientResponse, ISearchClientParams } from '../redux/api/customer/customer.model';
import { BaseQueryParams } from '../providers/Global.model';
import { useSearchCustomersQuery } from '../redux/api/customer/customerApi';

const useTwClient = (
  getLatest?: boolean
): {
  clients: ClientResponse[];
  fetchClients: (name?: string, ids?: string[]) => void;
} => {
  const initialQuery: BaseQueryParams = {
    limit: 20,
    order_by: 'desc',
    sort_by: 'created_at'
  };

  const [clients, setClients] = useState<ClientResponse[]>([]);
  const [params, setParams] = useState<BaseQueryParams>(initialQuery);
  const [filterParams, setFilterParams] = useState<ISearchClientParams | undefined>({});
  const { data = { content: [], total: 0 } } = useSearchCustomersQuery({
    pageParams: params,
    filterParams
  });

  useEffect(() => {
    if (data && data.content) {
      setClients(data.content);
    }
  }, [JSON.stringify(data.content)]);

  const debounceSearch = useRef(
    // getLatest: get last 10 customers added
    debounce(({ name, getLatest, ids }: { name?: string; getLatest?: boolean; ids?: string[] }) => {
      const query: BaseQueryParams = {};
      const paramsFilters: ISearchClientParams = {};

      if (name) {
        paramsFilters.name = name;
      }
      if (ids && ids.length) {
        paramsFilters.ids = ids;
      }

      if (getLatest) {
        query.limit = 20;
        query.order_by = 'desc';
        query.sort_by = 'created_at';
      }
      setParams(query);
      setFilterParams(paramsFilters);
    }, 300)
  ).current;

  useEffect(() => {
    return (): void => debounceSearch.cancel();
  }, [debounceSearch]);

  const fetchClients = (name?: string, ids?: string[]): void => {
    if (!name && !getLatest) {
      debounceSearch.cancel();
      setClients([]);

      return;
    }

    if (!name && getLatest) {
      debounceSearch({ getLatest });

      return;
    }
    if (name) {
      debounceSearch({ name, ids });

      return;
    }
  };

  return { clients, fetchClients };
};

export default useTwClient;
